import React, { useState } from 'react';
import Slider from "react-slick";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Trans, useTranslation } from "react-i18next";
import cvFR from "./../assets/cv.pdf";
import cvEN from "./../assets/cv-en.pdf";


const Carousel = () => {
    const images = [
        require("./../assets/pc-cinecrush2.jpg"),
        require("./../assets/mobile-treehotel.jpg"),
        require("./../assets/pc-fermecyr.jpg"),
    ];
    const CV_BY_LANG = {
        fr: cvFR,
        en: cvEN,
    };
    const { t, i18n } = useTranslation();
    const lang = i18n.language.split("-")[0];


    const [activeSlide, setActiveSlide] = useState(0);

    const NextArrow = ({ onClick }) => (
        <button className="custom-arrow next" onClick={onClick} aria-label="Next slide">
            <FontAwesomeIcon icon={faChevronRight} />
        </button>
    );

    const PrevArrow = ({ onClick }) => (
        <button className="custom-arrow prev" onClick={onClick} aria-label="Previous slide">
            <FontAwesomeIcon icon={faChevronLeft} />
        </button>
    );


    const settings = {
        centerMode: true,
        centerPadding: "0px",
        infinite: true,
        slidesToShow: 1.7,
        slidesToScroll: 1,
        arrows: true,
        speed: 500,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        beforeChange: (_, next) => setActiveSlide(next),
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                },
            },
        ],
    };



    return (
        <div>
            <div className="carousel-container mt-5">
                <h3 className='mb-5 sousTitre'>{t('mes.projets')}</h3>
                <Slider {...settings}>
                    {images.map((img, i) => (
                        <div
                            key={i}
                            className={`slide-wrapper ${activeSlide === i ? "active-slide" : ""}`}
                        >
                            <img src={img} alt={`slide-${i}`} className="carousel-image" />
                        </div>
                    ))}
                </Slider>

                <div className="gradient-left"></div>
                <div className="gradient-right"></div>

            </div>
            <div className='d-flex justify-content-center finSection'>
                <a href="/projets" className="buttonFulled mt-5">{t('btn.see.all')}</a>
            </div>
        </div>


    )
}

export default Carousel;